<template>
  <list
    v-if="loadingStatus === null || loadingStatus === true"
    v-show="loadingStatus === true"
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="false"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
    @error="loadingStatus = false"
    @succress="loadingStatus = true"
  />
  <div v-else-if="loadingStatus === false">
    <h4 class="text-error">Установите в журнале плановый урок</h4>
  </div>
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/timetables/${this.id}/media`;
    this.setLink = `business/timetables/${this.id}/media`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: false,
        },
        {
          key: "file_name",
          title: "Название файла",
          checkbox: false,
        },
        {
          key: "path",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
